import { _USER } from "@/state";
import { ziggyGetRoute as getRoute } from '@/router/ziggyGetRoute';

export default (to, from, next) => {
	if (!!_USER().isAuthenticated()) {
        return next(getRoute('accounts'))
    } else {
		return next();
	}
}